import {Component, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin} from "rxjs";
import {SkeletonModule} from "primeng/skeleton";
import {
  VisorComponent, SafeResourcePipe,
  SvgLoaderComponent, LoadingPanelService, Utils,
  SessionStorageService, AlertService, AlertIcon,
} from "lib-base";
import {ButtonDirective} from "primeng/button";
import {Router} from "@angular/router";
import {FacturaService} from "../../../../services/liquidacion/factura.service";
import {TramRegistroSolicitudService} from "../../../../services/tramiteRegistroSolicitud.service";
import {IResumenSolicitud} from "../../../../shared/interfaces/tramite";
import {
  IDataSolicitud,
  InfoReferenciaPago,
  RequestDetallesFactura
} from "../../../../shared/interfaces/liquidacion";
import {FacturaImpresaService} from "../../../../services/liquidacion/factura-impresa.service";
import {DatosPagoPseComponent} from "../../../../components/datos-pago-pse/datos-pago-pse.component";
import {PseTransactionService} from "../../../../services/recaudo/pse-transaction.service";
import {
  PseTransactionModel, PseTransactionSolicitud,
  RequestGeneraLinkPago,
  RequestTransactionByReference
} from "../../../../shared/interfaces/pse";
import {NgIf} from "@angular/common";
import {TramiteFirmasElectronicasService} from "../../../../services/tramiteFirmasElectronicas.service";

@Component({
  selector: 'app-consulta-pago',
  standalone: true,
  imports: [VisorComponent, SafeResourcePipe, SvgLoaderComponent, SkeletonModule,
    ButtonDirective, DatosPagoPseComponent, NgIf],
  templateUrl: './consulta-pago.component.html',
  styleUrl: './consulta-pago.component.scss'
})
export class ConsultaPagoComponent implements OnInit {
  #idTramite!: number;
  url: string | null = null;
  descripcionTramite: WritableSignal<string> = signal('');
  detalleTramite!: IResumenSolicitud;
  nombreBanco: string | undefined;
  translations: any = {};
  private loteFacturacion: number | undefined;
  visibleDatosPago: boolean = false;
  protected pseTransaction: PseTransactionModel | undefined;
  private infoReferenciaPago: InfoReferenciaPago | undefined;
  private ip?: string;

  @ViewChild(DatosPagoPseComponent) datosPagoPseComponent!: DatosPagoPseComponent;

  constructor(private _t: TranslateService, private _router: Router,
              private _tramSolicitudService: TramRegistroSolicitudService,
              private alertService: AlertService, private _lps: LoadingPanelService,
              private facturaImpresaService: FacturaImpresaService,
              private sessionStorage: SessionStorageService, private _dfes: TramiteFirmasElectronicasService,
              private pseTransactionService: PseTransactionService,
              private _factura: FacturaService) {
    this.getDataRouting();
  }

  ngOnInit() {
    this.translate().then();
    this.getIp();
    this.getDetallePago().then();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      continuar: this._t.get('common.continuar'),
      volver: this._t.get('form.button.atras'),
      aceptar: this._t.get('form.button.aceptar'),
      header: this._t.get('components.app-consulta-pago.header'),
      subHeader: this._t.get('components.app-consulta-pago.sub-header'),
      nombre: this._t.get('components.app-consulta-pago.nombre'),
      telefono: this._t.get('components.app-consulta-pago.telefono'),
      correo: this._t.get('components.app-consulta-pago.correo'),
      pagar: this._t.get('components.app-consulta-pago.pagar'),
      tramite: this._t.get('common.tramite'),
      descargar: this._t.get('common.descargar'),
      identificacion: this._t.get('components.app-consulta-pago.no-identificacion'),
      radicarTramite: this._t.get('components.app-create-tramite.radicar-tramite'),
      titleWarnMsg: this._t.get('form.msg.warn-summary'),
      messageWarnMsg: this._t.get('components.app-consulta-pago.msg-warn-detalle-factura'),
      messageWarnLinkPago: this._t.get('components.app-consulta-pago.msg-warn-genera-link'),
      messageWarnImpresionFactura: this._t.get('components.app-consulta-pago.msg-warn-impresion-factura'),

    }));
  }

  private getDataRouting = () => {
    const navigation = this._router.getCurrentNavigation();
    this.#idTramite = navigation?.extras.state?.['data'];
    if (this.#idTramite === undefined || this.#idTramite === null) {
      this._router.navigate(['/tramites/estado-tramite']).then();
    }
  };


  async iniciarPago() {
    this.guardaDetalleFactura();
    this.visibleDatosPago = true;
  }

  private async generaTransactionTicket(): Promise<void> {
    if (!this.loteFacturacion || !this.infoReferenciaPago) {
      return;
    }
    const body: RequestTransactionByReference = {
      lote: this.loteFacturacion,
      identificacion: this.detalleTramite.identificacion,
      impuesto: this.detalleTramite.impuesto,
      propietario: this.infoReferenciaPago.propietario,
      descripcion: this.infoReferenciaPago.descripcion,
      valorPagar: this.infoReferenciaPago.valorPagar,
      tipoFactura: this.infoReferenciaPago.tipoFactura,
      contribuyente: this.infoReferenciaPago.contribuyente,
      identificador: this.#idTramite,
      ip: this.ip,
      tipoIdentificacion: this.infoReferenciaPago.tipoIdentificacion
    };
    return await firstValueFrom(this.pseTransactionService.generaTransaccionByReferencia(body)).then(resp => {
      this.pseTransaction = resp
    })
  }

  private getIp(): void {
    this._dfes.getIPAddress().subscribe(resp => this.ip = resp.ip)
  }

  private async getDetallePago(): Promise<void> {
    if (!this.#idTramite)return;
    this._tramSolicitudService.getResumenSolicitud(this.#idTramite).subscribe({
      next: value => {
        this.detalleTramite = value;
        this.descripcionTramite.set(
          `${value.tramiteDescripcion} ${(value.subTramite) ? value.subTramite : ''} `
        );
        this.generaImpresion().then(() => this.getInfoReferenciaPago());

      }
    });
  }

  async generaImpresion() {
    this._lps.show();

    try {

      let loteFactura = !(await this.existeFactura()) ?
        await this.crearFactura(this.#idTramite).then() :
        await this.getLoteFactura(this.#idTramite).then();
      if (!loteFactura) {
        this._lps.hide();
        this.alertService.show({
          icon: AlertIcon.WARN,
          title: this.translations.titleWarnMsg,
          text: this.translations.messageWarnMsg,
          showAccept: true
        });
        return;
      }

      this.loteFacturacion = loteFactura;
      await this.imprimir(loteFactura);
    } catch (err) {
      console.error(err)
    }
  }

  async imprimir(lote: number) {
    this._lps.show();
    try {
      const file = await this.imprimirFactura(lote).then();
      if (file.size)
        this.url = URL.createObjectURL(file);
      this._lps.hide();
    } catch (err) {
      console.error(err);
      this._lps.hide();
    }

  }

  async crearFactura(solicitud: number) {
    return await firstValueFrom(this._factura.createFactura({solicitud})).then()
  }

  getInfoReferenciaPago() {
    const body: RequestDetallesFactura = {
      impuesto: this.detalleTramite.impuesto,
      lote: this.loteFacturacion
    };
    this.facturaImpresaService.getDetalleFacturaByReferenceOrImpAndDoc(body)
      .subscribe({
        next: value => {
          this.infoReferenciaPago = value;
          this.generaTransactionTicket().then();
        }
      })
  }

  async generarLinkPago(request: RequestGeneraLinkPago) {
    if (!request) return;
    request.documentoId = this.loteFacturacion;
    this._lps.show();

    this.sessionStorage.setItem(this.sessionStorage.SOLICITUD_PSE, {
      solicitud: this.#idTramite, ticketId: request.ticketId,
      nombreBanco: this.nombreBanco, lote: this.loteFacturacion,
      tipoFactura: this.infoReferenciaPago?.tipoFactura,
      radicado: this.detalleTramite.radicado
    } as PseTransactionSolicitud);

    this.pseTransactionService.generaLinkpago(request).subscribe({
      next: value => {
        if (value.returnCode == 'SUCCESS') {
          window.location.href = value.link;
        } else {
          if (!value.message) return
          this.alertService.show({
            icon: AlertIcon.WARN,
            title: this.translations.titleWarnMsg,
            text: value?.message,
            showAccept: true
          }).subscribe(event => {
            if (event.accept) this.volver()
          });
        }
        this._lps.hide();
      }, error: () => {
        this.alertService.show({
          icon: AlertIcon.WARN,
          title: this.translations.titleWarnMsg,
          text: this.translations.messageWarnLinkPago,
          showAccept: true
        }).subscribe(event => {
          if (event.accept)
            this.volver();
        })
      }
    })

  }


  async imprimirFactura(lote: number): Promise<Blob> {
    return await firstValueFrom(this._factura.imprimirFactura(lote))
      .catch(() => {
        this.alertService.show({

          data: {
            icon: AlertIcon.WARN,
            title: this.translations.titleWarnMsg,
            text: this.translations.messageWarnImpresionFactura,
            showAccept: true,
            positionBtn: 'center',
            acceptButton: {
              label: this.translations.aceptar,
              class: 'border-rounded-xl bg-indigo-600 hover:bg-indigo-400',
            }
          },
        });
        return Promise.resolve(new Blob());
      })
  }

  guardaDetalleFactura() {
    this.sessionStorage.setItem("data-solicitud",
      {solicitud: this.#idTramite, lote: this.loteFacturacion} as IDataSolicitud)
  }

  async getLoteFactura(solicitud: number): Promise<number> {
    return await firstValueFrom(this.facturaImpresaService.getLoteFacturacionBySolicitud(solicitud));
  }

  async existeFactura(): Promise<boolean> {
    return await firstValueFrom(this._factura.existe(this.#idTramite)).then();
  }

  volver() {
    this._router.navigate(['/tramites/estado-tramite'],
      {queryParams: {tabIndex: 1}}).then();
  }

  get isMobile() {
    return Utils.isMobile();
  }
}
